<form (ngSubmit)="saveTemplate()" [formGroup]="form">
	<h1 mat-dialog-title>{{'newOrderTemplateView.title' | translate}}</h1>
	<mat-dialog-content>
		<div fxLayout="column" fxLayoutAlign="start" fxLayoutGap="15px">
			<p>{{'newOrderTemplateView.instructions' | translate}}</p>
			<mat-form-field fxFlex>
				<mat-label>{{'newOrderTemplateView.templateNameLabel' | translate}}</mat-label>
				<input appTemplateExists [custId]="custId" [originalTemplateName]="originalTemplateName" formControlName="name" matInput required type="text"/>
				<mat-error *ngIf="form?.get('name')?.errors?.required">
					{{'newOrderTemplateView.templateNameLabel' | translate}} is required
				</mat-error>
				<mat-error *ngIf="form?.get('name')?.errors?.templateExists">
					{{'newOrderTemplateView.templateNameTakenText' | translate}}
				</mat-error>
			</mat-form-field>
		</div>
	</mat-dialog-content>
	<mat-dialog-actions fxLayout="row" fxLayoutAlign="end" fxLayoutGap="5px">
		<button [color]="'accent'" mat-dialog-close mat-raised-button type="button">
			{{'newOrderTemplateView.cancelButton' | translate}}
		</button>
		<button [color]="'primary'" [disabled]="form.invalid || form.pending" mat-raised-button type="submit">
			{{'newOrderTemplateView.saveButton' | translate}}
		</button>
	</mat-dialog-actions>
</form>
